/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import can from 'can/view/view';
import Control from 'can/control/control';
import 'can/construct/super/super';
import 'can/construct/proxy/proxy';
import 'can/control/plugin/plugin';
import 'can/view/bindings/bindings';
import appContext from 'scripts/app-context';
import 'scripts/utils/registerStacheHelpers';

export default Control.extend({
    constructorExtends: false
}, {
    setup: function (element, options) {
        options = options || {};
        options.appContext = appContext;

        let result = this._super(element, options);

        this.$element = this.element;
        this.can = can;
        this.$ = can.$;

        return result;
    }
});
